import type { FC, ReactNode } from 'react';
import React from 'react';
import { Typography, InlineNotification } from '@packages/shared';

export type InformationBoxProps = {
  /** how should the content be rendered */
  type: 'PARAGRAPH' | 'LIST';
  /** an array of items to render */
  items: Array<ReactNode | string>;
};

/**
 * InformationBox component
 *
 * used to display information
 * */
export const InformationBox: FC<InformationBoxProps> = ({ type, items }) => {
  const [uuid] = React.useState(React.useId());

  return (
    <InlineNotification severity="info" sx={{ alignItems: 'flex-start', p: 1 }}>
      {items.map((item, index) => (
        <Typography
          variant="body2"
          key={`${uuid}${index.toString()}`}
          sx={
            type === 'LIST'
              ? {
                  display: 'list-item',
                  listStyleType: 'disc',
                  listStylePosition: 'outside',
                  ml: 2,
                }
              : { mb: 1, ':last-child': { mb: 0 } }
          }
        >
          {item}
        </Typography>
      ))}
    </InlineNotification>
  );
};
